<div class="drop-down-container" [ngClass]="{'has-errors': hasErrors}">
  <boi-validation-error-generic (errorChange)="onErrorChange($event)" [validationErrors]="validationErrors"
    [propertyNames]="validationPropertyNames">
  </boi-validation-error-generic>

  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined"
        [forceRequired]="forceRequired">
        <div class="label-content" [ngClass]="{'position-relative': !isTooltipLast}">
          <label [for]="controlId ? controlId : labelName"
            [innerHtml]="dropDownLabel ? dropDownLabel : (labelName | localizeLabel)">
          </label>
        </div>
        <boi-tooltip *ngIf="showTooltip && !isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName"
        class="tooltip"></boi-tooltip>
      </div>

      <div class="field-input">
        <kendo-dropdownlist [data]="optionList ? (optionList | localizeOptionList) : availableOptions"
          [valuePrimitive]="valuePrimitive" [textField]="textField" [id]="controlId ? controlId : labelName"
          [valueField]="valueField" [(ngModel)]="value" [disabled]="isFieldDisabled" [defaultItem]="defaultItem"
          [popupSettings]="{popupClass: dropDownPopupCssClass}">
        </kendo-dropdownlist>
      </div>
      <boi-tooltip *ngIf="showTooltip && isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName"
      class="tooltip"></boi-tooltip>
    </div>
  </kendo-textbox-container>
</div>